import { render, staticRenderFns } from "./ComposeEmailIcon.vue?vue&type=template&id=49d8c5d8&scoped=true&"
import script from "./ComposeEmailIcon.vue?vue&type=script&lang=js&"
export * from "./ComposeEmailIcon.vue?vue&type=script&lang=js&"
import style0 from "./ComposeEmailIcon.vue?vue&type=style&index=0&id=49d8c5d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d8c5d8",
  null
  
)

export default component.exports